
window.OnLoginReady = function () {

    $('.floatl').each(function () {
        new Floatl($(this));
    });

    $('#language').change(function () {
        ChangeLanguage($("#language option:selected").attr('data-val'));
    });

    $('#loginBtn').click(function () {
        ValidateForm();
    });

    // Init validation form
    $.validate({ validateHiddenInputs: true });

    // Set default country if specified in cis system
    var defaultCountry = $("#defaultCountry").val();
    if (defaultCountry != '') {
        $("#country").val(defaultCountry);
    }

    // Set default languages 
    var defaultLanguage = $("#defaultLanguage").val();
    if (defaultLanguage != '') {
        $("#language").val(defaultLanguage);
    }

    $("#loginBtn").prop('disabled', false);
}

window.onloadCallback = function () {

    var windowWidth = $(window).width();

    // option to captcha
    //var captchaOptions = {
    //    sitekey: $("#recaptchaSiteKey").val(),
    //    size: 'invisible',
    //    badge: windowWidth <= 768 ? 'inline' : 'bottomright',
    //    callback: window.Login
    //};

    // Only for "invisible" type. if true, will read value from html-element's data-* attribute if its not passed via captchaOptions
    var inheritFromDataAttr = true;

    // now render
    //recaptchaId = window.grecaptcha.render("recaptcha", captchaOptions, inheritFromDataAttr);

    // Enabled the login button after recaptcha is loaded
    $("#loginBtn").prop('disabled', false);
}

window.EnterLogin = function (e) {
    if (e.keyCode == 13) {
        $('#loginBtn').click();
    }
}

window.ChangeLanguage = function (val) {
    document.location.href = "/Brand/" + $("#brandCode").val() + "/Account/SetLanguage?lang=" + val + "&returnUrl=" + window.location.href;
}

window.ValidateForm = function () {

    // Hide the previus messag if any
    $("#loginError").toggle(false);
    $("#loginError").html("");

    if (!$('#loginForm').isValid(null, { validateHiddenInputs: true }, true)) {
        return;
    }

    // Display the login spinner and disable the button
    $("#loginSpin").removeClass("invisible").addClass("visible");
    $("#loginBtn").prop('disabled', true);

    window.Login();

    //if (grecaptcha.getResponse() != '') {
    //    grecaptcha.reset();
    //}

    //grecaptcha.execute();
}

window.Login = function (gtoken) {
    $.ajax({
        type: "POST",
        datatype: 'html',
        url: "/Brand/" + $("#brandCode").val() + "/Account/Login/",
        data: {
            serviceNumber: $("#serviceNumber").val(),
            password: $("#password").val(),
            sapSystems: $("#country option:selected").data("sap").split(';'),
            countryCode: $("#country option:selected").data("code"),
            salesOrg: $("#country option:selected").data("salesorg"),
            lang: $("#language").val(),
        },
        success: function (data) {
            if (data.success)
            {
                window.location.href = "/Brand/" + $("#brandCode").val() + "/Service";
            }
            else
            {
                $("#loginError").toggle(true);
                $("#loginError").html(data.message);

                $("#loginSpin").removeClass("visible").addClass("invisible");
                $("#loginBtn").prop('disabled', false);
            }
        },
        error: function (xhr, status, error) {
            $("#loginError").toggle(true);
            $("#loginError").html(xhr.responseText);
        }
    });
}



